export const DEFAULT_DATE_TIME_FORMAT = 'MM-dd-yyyy hh:mm aa';

export const ERROR_TYPES = {
    INVALID_DATE_FORMAT: 'INVALID_DATE_FORMAT',
    INVALID_MONTH_FORMAT: 'INVALID_MONTH_FORMAT',
    LESS_THAN_MIN_DATE: 'LESS_THAN_MIN_DATE',
    GREATER_THAN_MAX_DATE: 'GREATER_THAN_MAX_DATE',
} as const;

export type ErrorType = (typeof ERROR_TYPES)[keyof typeof ERROR_TYPES];

export const ERROR_MESSAGES = {
    INVALID_MONTH_FORMAT: 'Please make sure the month you entered is a value from 1 to 12.',
    INVALID_DATE_FORMAT: (currentDate: string) =>
        `Invalid date. Please re-enter the date in the correct format (e.g. ${currentDate})`,
    OUT_OF_RANGE: (minYear: number, maxDateValue: string) =>
        `Please enter a date between ${minYear} and ${maxDateValue}.`,
};
